module.exports = __webpack_public_path__ + "h5/img/logo1.dfd198f4.png";